<template>
  <div :class="wrapperClasses">
    <template v-for="slotName in slotNames">
      <div v-if="slotName === 'main'" class="grow-box" :key="slotName">
        <div :class="growInnerBoxClasses" @mouseenter="showScroll = true" @mouseleave="showScroll = false">
          <slot :name="slotName" />
        </div>
      </div>
      <slot v-else :name="slotName" class="shrink-box" />
    </template>
  </div>
</template>
<script>
// 说明：本组件能放任意slot，需要自适应高度(分配剩余高度)的盒子请将slot name设置为main

// 利用弹性盒子实现滚动的高度
export default {
  name: 'FlexScrollBox',
  props: {
    layout: {
      type: String,
      default: 'vertical', // [vertical, horizontal]
      validator(val) {
        return ['vertical', 'horizontal'].includes(val)
      },
    },
  },
  data() {
    return {
      showScroll: false
    }
  },
  computed: {
    slotNames() {
      return Object.keys(this.$slots)
    },
    wrapperClasses() {
      return `flex-scroll-wrapper flex-scroll-${this.layout}`
    },
    growInnerBoxClasses() {
      return this.showScroll ? 'grow-box-inner' : 'grow-box-inner hide-scroll'
    }
  },
}
</script>
<style lang="less" scoped>
.flex-scroll-wrapper {
  display: flex;

  &.flex-scroll-vertical {
    flex-direction: column;
    height: 100%;
  }

  &.flex-scroll-horizontal {
    flex-direction: row;
    width: 100%;
  }

  & > .grow-box {
    flex-grow: 1;
    position: relative;
    & > .grow-box-inner {
      position: absolute;
      top: 0;
      left: 0;
      height: 100%;
      width: 100%;
      overflow: auto;

      &.hide-scroll {
        &::-webkit-scrollbar-thumb {
          background: transparent !important;
        }
      }
    }
  }
  & > .shrink-box {
    flex-shrink: 0;
  }
}
</style>
